/**
 * The GraphQL limits (F-125).
 *
 * Here rather than in the API package because both ends need them: the server
 * enforces them and the screen states them. A number the screen carries
 * separately is a number that will one day say 4 while the server refuses at
 * 3, and the person reading the screen is the one who finds out.
 */

/** How deeply one query may nest. Three objects deep is a real question. */
export const GRAPHQL_MAX_DEPTH = 4;

/**
 * What one request may cost, in database queries.
 *
 * Twenty-five companies, each with twenty-five contacts, each fetching its own
 * company back is 651 - a genuinely expensive question that looks like three
 * lines. Five and five is 31.
 */
export const GRAPHQL_MAX_COST = 500;

/** Rows a list is assumed to return when the query does not say. */
export const GRAPHQL_DEFAULT_PAGE = 25;

/**
 * The field inside a page that holds the rows.
 *
 * Used by the schema builder to name it and by the pricer to skip it, so the
 * two cannot disagree about which field is the wrapper. It costs nothing: the
 * rows were paid for by the query that produced the page.
 */
export const GRAPHQL_PAGE_FIELD = 'records';
